var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgIconGiftcard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 25.347,
    viewBox: "0 0 40 25.347",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.b{font-size:14px;font-family:SDJeongche830i, Sandoll Jeongche;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1380 -514.089)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1380 420.307)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 93.782)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M37.191,93.782H33.24a.586.586,0,0,0,0,1.172h3.951a1.639,1.639,0,0,1,1.637,1.637V116.32a1.638,1.638,0,0,1-1.637,1.637H2.809a1.639,1.639,0,0,1-1.637-1.637v-7.639L14.9,94.954h16a.586.586,0,0,0,0-1.172H2.809A2.812,2.812,0,0,0,0,96.591V116.32a2.812,2.812,0,0,0,2.809,2.809H37.191A2.812,2.812,0,0,0,40,116.32V96.591A2.812,2.812,0,0,0,37.191,93.782ZM1.172,96.591a1.639,1.639,0,0,1,1.637-1.637H8.725l-7.553,7.553Zm0,7.574,9.211-9.211h2.859L1.172,107.023Z",
    transform: "translate(0 -93.782)"
  }))), /*#__PURE__*/React.createElement("text", {
    className: "b",
    transform: "translate(1400 532)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10.906,
    y: 0
  }, "Gift")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGiftcard);
export default __webpack_public_path__ + "static/media/icon-giftcard.383ae7fa10ea36586e4dbd62896b3d4b.svg";
export { ForwardRef as ReactComponent };